import { useState } from 'react';
import { breaks } from '~/theme';
import { useEffectOnce } from 'react-use';
import { cardsWidthOptions } from '../CarouselDrag';

export const useCardsWidth = () => {
    const [cardWidth, setCardWidth] = useState(cardsWidthOptions.xs);

    const updateCardToScroll = () => {
        const clientWidth = window.innerWidth || 0;
        if (clientWidth >= breaks.md) {
            setCardWidth(cardsWidthOptions.md);
        } else if (clientWidth >= breaks.sm) {
            setCardWidth(cardsWidthOptions.sm);
        } else {
            setCardWidth(cardsWidthOptions.xs);
        }
    };

    useEffectOnce(() => {
        updateCardToScroll();
        window.addEventListener('resize', updateCardToScroll);

        return () => window.removeEventListener('resize', updateCardToScroll);
    });

    return { cardWidth };
};
